import tippy from 'tippy.js';
import './hint-tippy.scss';

export const hintTippyInit = function (){
    tippy(document.querySelectorAll('.hint-tippy'), {
        delay: 100,
        duration: 100,
        followCursor: true,
        size: 'small',
        theme: 'light',
        animation: 'fade',
        placement: 'bottom-start'
    });
};

export const hintTippyInitByClass = function (classDomEl){
    tippy(classDomEl, {
        delay: 100,
        duration: 100,
        followCursor: true,
        size: 'small',
        theme: 'light',
        animation: 'fade',
        placement: 'bottom-start'
    });
};
